import { render, staticRenderFns } from "./BulkOperationButtons.vue?vue&type=template&id=b123645c&scoped=true&"
import script from "./BulkOperationButtons.vue?vue&type=script&lang=js&"
export * from "./BulkOperationButtons.vue?vue&type=script&lang=js&"
import style0 from "./BulkOperationButtons.vue?vue&type=style&index=0&id=b123645c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b123645c",
  null
  
)

export default component.exports